import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';

import { PageNotFoundService } from './page-not-found.service';

@Component({
  selector: 'remote-update-domain-app-page-not-found',
  templateUrl: './page-not-found.html',
  styleUrls: ['./page-not-found.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton]
})
export class PageNotFound implements OnDestroy {
  private pageNotFoundService = inject(PageNotFoundService);
  private router = inject(Router);

  constructor() {
    this.pageNotFoundService.isPageNotFound.set(true);
  }

  ngOnDestroy() {
    this.pageNotFoundService.isPageNotFound.set(false);
  }

  navigateToAllDevices() {
    this.pageNotFoundService.isPageNotFound.set(false);
    this.router.navigate(['/all-devices']);
  }
}
